// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/* Router Modules */
// import componentsRouter from './modules/components'
import storeRouter from './modules/store';
import orderRouter from './modules/order';
import userRouter from './modules/user';
import distributionRouter from './modules/distribution';
import marketingRouter from './modules/marketing';
import integralRouter from './modules/integral'; // 积分（独立，不在 marketing 下）
import financialRouter from './modules/financial';
import contentRouter from './modules/content';
import operationRouter from './modules/operation';
import appSettingRouter from './modules/appSetting';
import maintainRouter from './modules/maintain';
import mobileRouter from './modules/mobile';
import statistic from './modules/statistic';
import businessRouter from './modules/business';
import appletRouter from './modules/applet';
import mealOrder from './modules/mealOrder';
import offsetRouter from './modules/offStore';
import offsetHomeRouter from './modules/offsetHome';
import welfareRouter from './modules/welfare';
import Cookies from 'js-cookie';
import dataRouter from './modules/data';
import sjtAndminRouter from './modules/sjt';
import raffleRouter from './modules/raffle';
import dentalRouter from './modules/dental';
import rsManagementRouter from './modules/rsManagement';
import invoiceRouter from './modules/invoice';
import rsRouter from './modules/rs';
import jdStoreRouter from './modules/jdStore';
import samStoreRouter from './modules/samStore';
import orderViewConfigRouter from './modules/orderViewConfig';
import merchantReconciliationRouter from './modules/merchantReconciliation';
import instantDiscountRouter from './modules/instantDiscount';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 *
 */
function getDefaultPath() {
  var JavaInfo;
  if (Cookies.get('JavaInfo')) {
    JavaInfo = JSON.parse(Cookies.get('JavaInfo'));
    console.log(JavaInfo, 'JavaInfo');
  } else {
    JavaInfo = {
      isoffine: false
    };
  }

  // 这里可以根据业务逻辑动态返回路径
  return JavaInfo.isoffine ? '/offsetHome' : '/dashboard'; // 例如返回 '/dynamic-dashboard'
}
export var constantRoutes = [
// 商品
storeRouter,
// 订单
orderRouter,
// 会员
userRouter,
// 分销
distributionRouter,
// 营销
marketingRouter,
// 积分（独立，不在 marketing 下）
integralRouter,
// 财务
financialRouter,
// 内容
contentRouter,
// 设置
operationRouter,
// 应用
appSettingRouter,
// 维护
maintainRouter,
//移动端管理
mobileRouter,
// 统计管理
statistic,
//企业管理
businessRouter,
// 小程序管理
appletRouter, mealOrder,
//核销首页
offsetHomeRouter,
// 核销列表
offsetRouter,
//三甲通
sjtAndminRouter,
// 福卡管理
welfareRouter,
// 统计
dataRouter,
//抽奖
raffleRouter,
// 华西口腔管理
dentalRouter,
// RS管理
rsRouter,
// 仁寿相关管理
rsManagementRouter,
// 京东管理
jdStoreRouter,
// 山姆管理
samStoreRouter,
// 订单查看配置
orderViewConfigRouter,
// 商家对账
merchantReconciliationRouter,
// 立减活动管理
instantDiscountRouter,
//财务相关
invoiceRouter, {
  path: '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}, {
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path(.*)',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/auth-send',
  component: function component() {
    return import('@/views/mobile/auth-send');
  },
  hidden: true
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return import('@/views/login/auth-redirect');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: getDefaultPath(),
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'Dashboard',
    meta: {
      title: '主页',
      icon: 'dashboard',
      affix: true
    }
  }, {
    path: 'product',
    name: "product",
    meta: {
      title: '商品统计'
    },
    component: function component() {
      return import('@/views/statistic/product/index');
    }
  }, {
    path: 'statuser',
    name: "statuser",
    meta: {
      title: '用户统计'
    },
    component: function component() {
      return import('@/views/statistic/user/index');
    }
  }, {
    path: 'transaction',
    name: "transaction",
    meta: {
      title: '交易统计'
    },
    component: function component() {
      return import('@/views/statistic/transaction/index');
    }
  }]
}, {
  path: '/setting/uploadPicture',
  component: function component() {
    return import('@/components/uploadPicture/index.vue');
  },
  name: 'uploadPicture'
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;